import { combineReducers } from "@reduxjs/toolkit";
import structure from "../../features/structures/store/structure.slice";
import tables from "../../features/tables/store/tables.slice";
import browse from "../../features/documents/store/browse.slice";
import settings from "../../features/settings/store/settings.slice";
import documents from "../../features/documents/store/documents.slice";
import { documentsApi } from "../../features/documents/api/documents.api";
import { documentsSettingsApi } from "../../features/documents/api/documentsSettings.api";
import { documentsStructureApi } from "../../features/structures/api/documentsStructure.api";
import { systemTablesApi } from "../../features/tables/api/systemTables.api";
import { customTablesApi } from "../../features/tables/api/customTables.api";
import { accountsStructureApi } from "../../features/structures/api/accountsStructure.api";
import { accountsApi } from "../../features/tickets/public";
import { carsApi } from "../../features/tickets/api/cars.api";
import { itemsApi } from "../../features/tickets/api/items.api";
import { worksApi } from "../../features/tickets/api/works.api";
import { entriesApi } from "../../features/tickets/api/entries.api";

export const rootReducer = combineReducers({
  structure,
  tables,
  browse,
  settings,
  documents,
  [documentsApi.reducerPath]: documentsApi.reducer,
  [documentsSettingsApi.reducerPath]: documentsSettingsApi.reducer,
  [documentsStructureApi.reducerPath]: documentsStructureApi.reducer,
  [systemTablesApi.reducerPath]: systemTablesApi.reducer,
  [customTablesApi.reducerPath]: customTablesApi.reducer,
  [accountsStructureApi.reducerPath]: accountsStructureApi.reducer,
  [accountsApi.reducerPath]: accountsApi.reducer,
  [carsApi.reducerPath]: carsApi.reducer,
  [itemsApi.reducerPath]: itemsApi.reducer,
  [worksApi.reducerPath]: worksApi.reducer,
  [entriesApi.reducerPath]: entriesApi.reducer,
});
